import React from 'react';

const headingConstants = [{ text: 'New at JB!', decoratedText: 'New' }];

export const buildDecoratedText = (
  text: string | undefined,
  className?: string
): { decoratedContent: React.ReactNode; hasDecoratedHeading: boolean } => {
  const matchedText = headingConstants.find(
    heading => heading.text?.trim()?.toLowerCase() === text?.trim()?.toLowerCase()
  );
  const { decoratedText } = matchedText ?? {};

  if (!text || !decoratedText) {
    return { decoratedContent: text, hasDecoratedHeading: false };
  }
  const regex = new RegExp(`(${decoratedText})`, 'i');
  const parts = text.split(regex);
  const decoratedContent = parts.map((part, idx) => {
    const isDecorated = regex.test(part);
    return isDecorated ? (
      <span key={idx} className={className}>
        {part}
      </span>
    ) : (
      <span key={idx}>{part}</span>
    );
  });
  return { decoratedContent, hasDecoratedHeading: true };
};
